import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import React from 'react';

import CopyIcon from '@/assets/icons/copy.svg?react';
import { useToast } from '@/hooks/useToast';
import { useTranslator } from '@/hooks/useTranslator';

interface Props {
  readonly value: string;
  readonly successMessageKey?: string;
}

export const CopyableValue: React.FC<Props> = (props: Props): React.ReactElement => {
  const { value, successMessageKey = 'COPIED_TO_CLIPBOARD' } = props;
  const toast = useToast();
  const tr = useTranslator();

  const onCopy = React.useCallback((): void => {
    navigator.clipboard.writeText(value).then((): void => {
      toast.show(tr(successMessageKey), 'success');
    });
  }, [value, toast, tr, successMessageKey]);

  return (
    <Box display="flex" alignItems="center">
      <Typography
        variant="body2"
        sx={{
          wordBreak: 'break-all',
          flex: 1,
        }}>
        {value}
      </Typography>
      <Box height="1em" display="flex" alignItems="center" ml={1}>
        <IconButton color="primary" size="small" onClick={onCopy}>
          <CopyIcon fill="currentColor" width={16} height={16} />
        </IconButton>
      </Box>
    </Box>
  );
};
